import { useStore } from '@/store'
import './commonModal.scss'
import dialogPolyfill from 'dialog-polyfill'
import React, { ReactNode, useEffect, useRef } from 'react'

interface CommonModalProps {
  title: string
  open: boolean
  desc?: string
  type?:
    | 'common'
    | 'rule'
    | 'alert'
    | 'record'
    | 'share'
    | 'select-role'
    | 'receive'
    | 'rewardPreview'
    | ModalType
  length?: 'normal' | 'long' | 'short'
  children?: ReactNode[]
  onBodyClick?: () => void
  onClose?: () => void
}
export default function CommonModal(props: CommonModalProps) {
  const { open, desc, title, type, length, children, onBodyClick, onClose } =
    Object.assign(
      {
        open: false,
        title: '',
        type: 'common',
        length: 'normal',
      },
      props
    )

  const id = `${type}-modal`

  const modalRef = useRef<HTMLDialogElement>(null)

  const { dispatch } = useStore()

  useEffect(() => {
    const modalElem = modalRef.current
    if (modalElem) {
      dialogPolyfill.registerDialog(modalElem)
      modalElem.onkeydown = (e) => {
        if (e.key === 'Escape') {
          e.preventDefault()
        }
      }
      if (open) {
        modalElem.showModal()
      }
    }

    return () => {
      if (modalElem) {
        modalElem.open = false
      }
    }
  }, [open])

  const bodyHandleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation()
    onBodyClick instanceof Function && onBodyClick()
  }

  const close = () => {
    onClose instanceof Function && onClose()

    if (type === 'alert') return

    dispatch({
      type: 'closeModal',
    })
  }

  return open ? (
    <>
      <dialog
        ref={modalRef}
        id={id}
        className={`common-modal common-modal--${length}`}
        onClick={close}
      >
        <div className="common-modal-cont" onClick={bodyHandleClick}>
          {type === 'share' ? null : (
            <div className="common-modal-header">
              <div className="common-modal-title">
                <span>{title}</span>
                <span>{title}</span>
              </div>
            </div>
          )}
          {children && <div className="common-modal-body">{children[0]}</div>}
          {children && children[1] ? (
            <div className="common-modal-footer">{children[1]}</div>
          ) : null}
        </div>
        {desc ? <div className="common-modal-desc">{desc}</div> : null}
        {type === 'alert' ? null : <div className="common-modal-close"></div>}
      </dialog>
      <div className="backdrop"></div>
    </>
  ) : null
}
